import React from 'react';
import styled, { css } from 'styled-components';

import { ManualCSSColors } from 'app/shared/theme';

import Registry from './registry';

const keys: string[] = Object.keys(Registry);

const generateIcons = () => {
  let styles = '';

  keys.map((k: string) => {
    styles += `
      &.icon-${k}:before {
        content: '\\${Registry[k as keyof typeof Registry]}';
      }
    `;
  });

  return css`
    ${styles}
  `;
};

const IconElement = styled.i<{
  className: string;
  size?: string;
  color?: ManualCSSColors;
}>`
  ${({ theme, size, color }) => css`
    font-family: 'sofarsounds-icon-font' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    &:before {
      color: ${theme.colors[color || 'black']};
    }

    ${
      size &&
      css`
        ${theme.media.xs`
          font-size: ${size};
        `}
      `
    }
  `}

  ${generateIcons()};
`;

interface IconProps {
  name: string;
  size?: string;
  color?: ManualCSSColors;
  className?: string;
  title?: string;
  'data-qaid'?: string;
  id?: string;
}

export const Icon: React.FC<React.PropsWithChildren<IconProps>> = ({
  name,
  size,
  color,
  title,
  className = '',
  'data-qaid': qaId,
  id,
}) => (
  <IconElement
    id={id}
    className={`icon-${name} ${className}`}
    size={size}
    color={color}
    title={title}
    data-qaid={qaId}
  />
);
